import { render, staticRenderFns } from "./assignTransaction.vue?vue&type=template&id=4993189b&scoped=true"
import script from "./assignTransaction.vue?vue&type=script&lang=js"
export * from "./assignTransaction.vue?vue&type=script&lang=js"
import style0 from "./assignTransaction.vue?vue&type=style&index=0&id=4993189b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993189b",
  null
  
)

export default component.exports